var map = {
	"./1/symbol_0.png": 58983,
	"./1/symbol_1.png": 6494,
	"./1/symbol_10.png": 62460,
	"./1/symbol_11.png": 75525,
	"./1/symbol_12.png": 3726,
	"./1/symbol_2.png": 92245,
	"./1/symbol_3.png": 56332,
	"./1/symbol_4.png": 32579,
	"./1/symbol_5.png": 68474,
	"./1/symbol_6.png": 89585,
	"./1/symbol_7.png": 79368,
	"./1/symbol_8.png": 9215,
	"./1/symbol_9.png": 12278,
	"./2/symbol_0.png": 52286,
	"./2/symbol_1.png": 4775,
	"./2/symbol_10.png": 74727,
	"./2/symbol_11.png": 56414,
	"./2/symbol_12.png": 23765,
	"./2/symbol_2.png": 2124,
	"./2/symbol_3.png": 38037,
	"./2/symbol_4.png": 14266,
	"./2/symbol_5.png": 84400,
	"./2/symbol_6.png": 25160,
	"./2/symbol_7.png": 41406,
	"./2/symbol_8.png": 58070,
	"./2/symbol_9.png": 55007,
	"./3/symbol_0.png": 22049,
	"./3/symbol_1.png": 920,
	"./3/symbol_10.png": 52266,
	"./3/symbol_12.png": 28536,
	"./3/symbol_2.png": 96531,
	"./3/symbol_3.png": 64618,
	"./3/symbol_4.png": 35045,
	"./3/symbol_5.png": 99132,
	"./3/symbol_6.png": 6711,
	"./3/symbol_7.png": 23566,
	"./3/symbol_8.png": 96601,
	"./3/symbol_9.png": 90352,
	"./4/symbol_0.png": 69304,
	"./4/symbol_1.png": 53921,
	"./4/symbol_10.png": 18997,
	"./4/symbol_12.png": 85735,
	"./4/symbol_2.png": 4938,
	"./4/symbol_3.png": 43795,
	"./4/symbol_4.png": 60188,
	"./4/symbol_5.png": 11986,
	"./4/symbol_6.png": 1454,
	"./4/symbol_7.png": 83204,
	"./4/symbol_8.png": 93936,
	"./4/symbol_9.png": 90841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86965;